import Currency from "./Currency"
import React from "react"

const SlashedPrice = ({originalPrice, currentPrice}) => {
  if (originalPrice > 0 && parseFloat(originalPrice) > parseFloat(currentPrice)) {
    return (
      <Currency className="rewards-plus-plp__original-price-label" value={originalPrice}/>
    )
  } else {
    return null
  }
}

export default SlashedPrice;
